import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { distinct, filter, from, groupBy, map, Observable, Subscription } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectAddedDeviceId, selectErrorDuplicateCrp, selectNewDeviceModels } from "src/app/store/device/device.selector";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { DeviceModel, NewDeviceModel } from "src/app/model/device-model";
import { AUTOMATION_CLASS_LIST } from "src/app/conf/automation-class";
import { TranslateService } from "@ngx-translate/core";
import { EDeviceModel } from "src/app/conf/device-models";
import { StandardNewValidator, StandardNewValidatorStepTabs, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { DeviceIcon, VIRTUAL_ICONS_VALUE } from "src/app/conf/device-icons";
import { Device } from "src/app/model/device";
import { EDeviceCategory } from "src/app/conf/device-categories";
import { DeviceInfo } from "src/app/model/device-info";
import { IOPayload } from "src/app/model/io-payload";
import { CustomValidators } from "src/app/validators/custom.validators";
import * as SiteActions from 'src/app/store/site/site.actions';
import { ActivatedRoute, Router } from "@angular/router";
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { ICON_CONVERT_AUTOMATICDOOR, ICON_CONVERT_BARRIER, ICON_CONVERT_CAMERA, ICON_CONVERT_GARAGE, ICON_CONVERT_LOAD, ICON_CONVERT_LOCK, ICON_CONVERT_SLIDINGGATE, ICON_CONVERT_SOUND, ICON_CONVERT_SWINGGATE, ICON_CONVERT_TAPPARELLA, ICON_CONVERT_TURNSTILE, ICON_CONVERT_VIRTUAL_DEVICE } from "src/app/conf/icon";

@Component({
	templateUrl: './add-automation.dialog.component.html',
})

export class AddAutomationDialogComponent implements OnInit, OnDestroy {
	models$: Observable<NewDeviceModel[] | undefined>;
	modelsSub: Subscription | undefined;


	addedDeviceId$: Observable<number | undefined>;
	addSub: Subscription;
	errorDuplicateCrp$: Observable<boolean | undefined>;
	errorDuplicateCrpSub: Subscription;


	addDeviceForm: FormGroup;
	models: NewDeviceModel[];
	modelSubGateway: NewDeviceModel[];
	selectIO: boolean;
	subGateway: boolean;

	model: NewDeviceModel;
	parentInfo: DeviceInfo;
	parentModel: DeviceModel;
	automationsCount: number;
	subGatewaysCount: number;

	boardClasses = AUTOMATION_CLASS_LIST;
	icons = VIRTUAL_ICONS_VALUE;
	boardClassSel: NewDeviceModel;
	series: string[];
	seriesSel: NewDeviceModel;
	filterModels: NewDeviceModel[];
	filterModelsType: NewDeviceModel[];
	filterBoards: NewDeviceModel[];
	parentDevice: Device;
	periphNumbers: number[] = [];

	screenWidth: number;
	activeIndex: number = 0;

	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		private fb: FormBuilder,
		public config: DynamicDialogConfig,
		private translate: TranslateService,
		private router: Router,
		private route: ActivatedRoute,
	) {
		this.initSelectors();
		if (config.data.parentDevice !== undefined && config.data.parentDevice !== null) {
			this.parentDevice = config.data.parentDevice;
		} else {
			this.parentDevice = new Device;
		}
		if (config.data.parentInfo !== undefined && config.data.parentInfo !== null) {
			this.parentInfo = config.data.parentInfo;
		} else {
			this.parentInfo = new DeviceInfo;
		}
		if (config.data.parentModel !== undefined && config.data.parentModel !== null) {
			this.parentModel = config.data.parentModel;
		} else {
			this.parentModel = new DeviceModel;
		}
		if (config.data.automationsCount !== undefined && config.data.automationsCount !== null) {
			this.automationsCount = config.data.automationsCount;
		} else {
			this.automationsCount = 0;
		}

		if (config.data.subGatewaysCount !== undefined && config.data.subGatewaysCount !== null) {
			this.subGatewaysCount = config.data.subGatewaysCount;
		} else {
			this.subGatewaysCount = 0;
		}
	}

	initSelectors(): void {
		this.models$ = this.store.select(selectNewDeviceModels);
		this.addedDeviceId$ = this.store.select(selectAddedDeviceId);
		this.errorDuplicateCrp$ = this.store.select(selectErrorDuplicateCrp);
	}

	ngOnInit(): void {
		this.selectIO = false;
		this.subGateway = false;

		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);

		StandardNewValidatorStepTabs.secondTabfields = [];

		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.selectedPeriphNumber, 1);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.selectedModel, 1);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.selectedBoard, 1);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.keyCode, 1);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.name, 1);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.description, 1);
	}

	ngOnDestroy(): void {
		this.modelsSub?.unsubscribe();
		this.addSub?.unsubscribe();
		this.errorDuplicateCrpSub?.unsubscribe();
	}

	subscribeAll(): void {
		this.errorDuplicateCrpSub = this.errorDuplicateCrp$?.subscribe(
			(errorDuplicateCrp) => {
				if (errorDuplicateCrp) {
					this.f?.selectedPeriphNumber.setErrors({ 'incorrect': true });
				} else {
					this.f?.selectedPeriphNumber.setErrors(null);
				}
			}
		);
		this.modelsSub = this.models$
			.pipe(
				map(models => this.supportedModels(models))
			)
			.subscribe(models => {
				this.models = models.filter(model => model.Id < 900 && model.CategoryId !== 2);
				this.modelSubGateway = models.filter(model => model.CategoryId === 2);
				const listBoardClass = Object.keys(this.models.reduce((r, { BoardClass }) => (r[BoardClass] = '', r), {}));


				const allClassList = Object.assign([], AUTOMATION_CLASS_LIST);
				allClassList.push({
					BoardClass: undefined,
					IconName: DeviceIcon.virtualdevice,
					BoardName: 'CLASS_VIRTUAL_DEVICE'
				});
				this.boardClasses = Object.assign([], allClassList.filter(clas => (clas.BoardClass !== 1000 && listBoardClass.includes(this.toStringUndeff(clas.BoardClass)) || (clas.BoardClass === 1000 && this.modelSubGateway !== undefined && this.modelSubGateway.length > 0))));
			}
			);
		this.addSub = this.addedDeviceId$
			.pipe(filter(deviceId => !!deviceId))
			.subscribe(deviceId => {
				this.store.dispatch(SiteActions.getSites({}));
				this.store.dispatch(DeviceVctActions.getSitesVctList());
				this.store.dispatch(SiteActions.getSitesOnlineDevices({}));
				this.store.dispatch(DeviceActions.getCurrentDevice({ deviceId }));
				this.dialogRef.close({ deviceId });
				const urlRoute = '../' + deviceId;
				this.router.navigate([urlRoute], { relativeTo: this.route });
			}
			);
	}

	toStringUndeff(num: number): string {
		if (num === undefined)
			return "undefined";
		return num.toString();
	}

	supportedModels(allModels: NewDeviceModel[]): NewDeviceModel[] {
		let models: NewDeviceModel[] = [];
		if ((this.parentInfo.AllowedInputs && this.parentInfo.AllowedInputs.length > 0) ||
			(this.parentInfo.AllowedOutputs && this.parentInfo.AllowedOutputs.length > 0)) {
			models = models.concat(allModels.filter(m => m.Id === EDeviceModel.MultiIO));
		}
		if (this.parentModel && this.parentModel.MaxSubGateways > this.subGatewaysCount
			&& this.parentModel.MaxAutomations > this.automationsCount) {
			const subGateways = allModels.filter(m => m.CategoryId === EDeviceCategory.SubGateway); // Automations + SubGateways
			const automations = allModels.filter(m => m.CategoryId === EDeviceCategory.Automation);
			models = models.concat(subGateways, automations); // puts subgateways at the beginning
		} else if (this.parentModel && this.parentModel.MaxSubGateways > this.subGatewaysCount
			&& this.parentModel.MaxAutomations <= this.automationsCount) {
			models = models.concat(
				allModels.filter(m => m.CategoryId === EDeviceCategory.SubGateway)); // Subgateways only
		} else if (this.parentModel && this.parentModel.MaxSubGateways <= this.subGatewaysCount
			&& this.parentModel.MaxAutomations > this.automationsCount) {
			models = models.concat(
				allModels.filter(m => m.CategoryId === EDeviceCategory.Automation)); // Automations only
		}
		return models;
	}

	buildForm(): void {
		const inputs = [];
		if (this.parentInfo.AllowedInputs !== undefined && this.parentInfo.AllowedInputs !== null) {
			for (const input of this.parentInfo.AllowedInputs) {
				inputs.push(this.fb.control(false));
			}
		}
		const outputs = [];
		if (this.parentInfo.AllowedOutputs !== undefined && this.parentInfo.AllowedOutputs !== null) {
			for (const output of this.parentInfo.AllowedOutputs) {
				outputs.push(this.fb.control(false));
			}
		}

		const device = new Device();
		device.CrpItemId = 1;
		this.addDeviceForm = new FormGroup({
			'selectedSeries': new FormControl(''),
			'selectedModel': new FormControl(device.ModelId),
			'selectedPeriphNumber': new FormControl(device.CrpItemId, Validators.required),
			'name': new FormControl(device.Name, Validators.required),
			'description': new FormControl(device.Description, Validators.required),
			'keyCode': new FormControl('', [Validators.required, Validators.minLength(16),
			Validators.maxLength(16), Validators.pattern('[0-9a-fA-F]+')]),
			'iconName': new FormControl(this.icons[0].value, Validators.required),
			'inputPorts': this.fb.array(inputs),
			'outputPorts': this.fb.array(outputs),
			'selectedBoard': new FormControl(device.ModelId, Validators.required),
		});
		this.addDeviceForm.addValidators(CustomValidators.multipleCheckboxRequireOneIO('inputPorts', 'outputPorts'));
	}

	goToIndexCheckandActive(direction: string) {
		if (direction === 'next') {
			this.changeActiveTabClick(1);
		} else { // 'back'
			this.changeActiveTabClick(0);
		}
	}

	changeActiveTabClick(index: number) {
		this.activeIndex = index;
	}

	getBoardClassIcon(codeType: string): string {
		if (this.activeIndex === 0) {
			switch (codeType) {
				case 'BOARD_USER':
					return 'cm-radio-controls';
				case 'KEYPAD':
					return 'cm-keypad';
				case 'TRANSPONDER':
					return 'cm-cards';
				default:
					return '';
			}
		} else if (codeType === 'BOARD_USER') {
			return 'cm-radio-controls';
		} else {
			return '';
		}
	}

	elaborateFilterModelsType(): void {
		this.filterModelsType = [];
		this.filterBoards = [];
		from(this.filterModels)
			.pipe(distinct(model => model.ProductName))
			.subscribe((model) => {
				this.filterModelsType.push(model);
			});
	}

	setBoardClass(boardClassSel: NewDeviceModel): void {
		this.boardClassSel = boardClassSel;
		this.filterModels = [];
		this.filterModelsType = [];
		this.filterBoards = [];
		this.f.selectedSeries.setValue(null);
		if (boardClassSel.BoardClass === undefined && boardClassSel.BoardName === 'CLASS_VIRTUAL_DEVICE') {
			this.selectIO = true;
			this.subGateway = false;
			this.series = [];
			const model = this.models.filter(mo => mo.CategoryId === 8); //Category virtual I/O
			if (model !== undefined && model.length > 0) {
				this.filterModels = model;
				if (model.length === 1) {
					this.f.selectedBoard.setValue(model[0]);
					this.onSelectedBoard();
				} else {
					this.f.selectedBoard.setValue(null);
				}
				this.elaborateFilterModelsType();
			}
		} else if (boardClassSel.BoardClass === 1000) {
			this.selectIO = false;
			this.subGateway = true;
			this.f.selectedModel.setValue(null);
			this.f.selectedBoard.setValue(null);
			this.model = null;
			this.f.description.setValue(null);
			this.filterModelsType = this.modelSubGateway;
			this.filterModels = this.modelSubGateway;
			this.filterBoards = [];
			this.series = [];
		} else {
			this.selectIO = false;
			this.subGateway = false;
			this.f.selectedModel.setValue(null);
			this.f.selectedBoard.setValue(null);
			this.model = null;
			this.f.description.setValue(null);
			const filterModel = this.models.filter(mo => mo.BoardClass === boardClassSel.BoardClass);
			const listSeries = [];
			from(filterModel).pipe(
				groupBy(p => p.SeriesName)
			).subscribe((groupedObservable) => {
				if (groupedObservable.key !== undefined && groupedObservable.key !== "") {
					listSeries.push(groupedObservable.key);
				}
			});
			if (listSeries != undefined && listSeries.length === 1) {
				this.f.selectedSeries.setValue(listSeries[0]);
				this.onSelectSeries();
			} else {
				this.f.selectedSeries.setValue(null);
			}
			this.series = listSeries.sort((a, b) => { return a < b ? -1 : 1 });
		}
		this.goToIndexCheckandActive('next');
	}

	onSelectSeries(): void {
		this.seriesSel = this.f.selectedSeries.value;
		this.filterModels = this.models.filter(mo => mo.SeriesName === this.seriesSel);
		this.elaborateFilterModelsType();
		if (this.filterModelsType !== null && this.filterModelsType.length === 1) {
			this.f.selectedModel.setValue(this.filterModelsType[0]);
			this.onSelectedModel();
		} else {
			this.f.selectedModel.setValue(null);
		}
	}

	boardClassButtonColor(boardClassSel: number): string {
		return (boardClassSel === this.boardClassSel) ? "bg-primary hover:bg-primary" : "text-color surface-100 hover:surface-500";
	}

	getBoardClassName(boardClassSel: number): string {
		switch (boardClassSel) {
			case 0:
				return 'a';
			case 1:
				return 'b';
			case 2:
				return 'c';
			default:
				return 'd';
		}
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.boardUserDialogReset());
		this.dialogRef.close('success');
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	get f(): any {
		return this.addDeviceForm !== undefined ? this.addDeviceForm.controls : undefined;
	}

	updateForm(): void {
		if (this.model !== undefined && this.model.CategoryId === EDeviceCategory.SubGateway) { // subgateway
			this.f.selectedPeriphNumber.disable();
			this.f.iconName.disable();
			this.f.keyCode.enable();
			this.f.inputPorts.disable();
			this.f.outputPorts.disable();
			this.addDeviceForm.removeValidators(CustomValidators.multipleCheckboxRequireOneIO('inputPorts', 'outputPorts'));
		} else if (this.model !== undefined && this.model.CategoryId === EDeviceCategory.Automation) { // automation
			this.periphNumbers = [];
			this.f.keyCode.disable();
			this.f.iconName.disable();
			this.f.inputPorts.disable();
			this.f.outputPorts.disable();
			this.f.selectedPeriphNumber.enable();
			for (let i = 1; i <= 254; i++) {
				this.periphNumbers.push(i);
			}
			this.addDeviceForm.removeValidators(CustomValidators.multipleCheckboxRequireOneIO('inputPorts', 'outputPorts'));
		} else if (this.multiIO()) {
			this.f.selectedPeriphNumber.disable();
			this.f.keyCode.disable();
			this.f.iconName.enable();
			this.f.inputPorts.enable();
			this.f.outputPorts.enable();
			this.addDeviceForm.addValidators(CustomValidators.multipleCheckboxRequireOneIO('inputPorts', 'outputPorts'));
		}
	}

	multiIO(): boolean {
		return this.model ? this.model.Id === EDeviceModel.MultiIO : false;
	}

	anyAllowedInputs(): boolean {
		return this.parentInfo.AllowedInputs && this.parentInfo.AllowedInputs.length > 0;
	}

	anyAllowedOutputs(): boolean {
		return this.parentInfo.AllowedOutputs && this.parentInfo.AllowedOutputs.length > 0;
	}

	terminals(): IOPayload[] {
		const terminals: IOPayload[] = [];
		const inputPorts = this.f.inputPorts.value;
		const outputPorts = this.f.outputPorts.value;
		for (let i = 0; i < inputPorts.length; i++) {
			if (inputPorts[i]) {
				terminals.push({
					InputId: this.parentInfo.AllowedInputs[i]
				});
			}
		}
		for (let i = 0; i < outputPorts.length; i++) {
			if (outputPorts[i]) {
				terminals.push({
					OutputId: this.parentInfo.AllowedOutputs[i]
				});
			}
		}

		return terminals;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.addDeviceForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.addDeviceForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				});
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	revertIcon(icon: string): string {
		switch ('cm-' + icon) {
			case ICON_CONVERT_VIRTUAL_DEVICE[1]: {
				return ICON_CONVERT_VIRTUAL_DEVICE[0];
			}
			case ICON_CONVERT_TAPPARELLA[1]: {
				return ICON_CONVERT_TAPPARELLA[0];
			}
			case ICON_CONVERT_LOCK[1]: {
				return ICON_CONVERT_LOCK[0];
			}
			case ICON_CONVERT_SOUND[1]: {
				return ICON_CONVERT_SOUND[0];
			}
			case ICON_CONVERT_CAMERA[1]: {
				return ICON_CONVERT_CAMERA[0];
			}
			case ICON_CONVERT_LOAD[1]: {
				return ICON_CONVERT_LOAD[0];
			}
			case ICON_CONVERT_AUTOMATICDOOR[1]: {
				return ICON_CONVERT_AUTOMATICDOOR[0];
			}
			case ICON_CONVERT_BARRIER[1]: {
				return ICON_CONVERT_BARRIER[0];
			}
			case ICON_CONVERT_SLIDINGGATE[1]: {
				return ICON_CONVERT_SLIDINGGATE[0];
			}
			case ICON_CONVERT_SWINGGATE[1]: {
				return ICON_CONVERT_SWINGGATE[0];
			}
			case ICON_CONVERT_GARAGE[1]: {
				return ICON_CONVERT_GARAGE[0];
			}
			case ICON_CONVERT_TURNSTILE[1]: {
				return ICON_CONVERT_TURNSTILE[0];
			}
			default: {
				return icon;
			}
		}
	}

	save(): void {
		const categoryId = this.filterModels.find(m => m.Id === +this.f.selectedBoard.value.Id).CategoryId;
		const device: Device = {
			SiteId: this.parentDevice.SiteId,
			Name: this.f.name.value,
			CrpItemId: this.f.selectedPeriphNumber.value && categoryId !== EDeviceCategory.Virtual ? this.f.selectedPeriphNumber.value : null,
			Description: this.f.description.value,
			ParentId: this.parentDevice.Id,
			RootId: this.parentDevice.RootId ? this.parentDevice.RootId : this.parentDevice.Id,
			ModelId: this.f.selectedBoard.value.Id,
			IconName: categoryId === EDeviceCategory.Virtual ? this.revertIcon(this.f.iconName.value).replace('cm-', '') : null,
			CategoryId: categoryId,
			Keycode: this.f.keyCode.value,
		};
		if (this.model.Id === EDeviceModel.MultiIO) {
			device.Terminals = this.terminals();
		}
		this.store.dispatch(DeviceActions.addDevice({ device }));
	}

	convertionModel(model: DeviceModel) {
		return model.ProductName ? model.ProductName : '';
	}

	convertionBoard(model: NewDeviceModel) {
		// return model.BoardName ? model.BoardName : '';
		return model.BoardProductName ? model.BoardProductName : '';
	}

	onSelectedModelGateway(): void {
		this.model = this.filterModels.find(m => m.Id === this.f.selectedBoard.value.Id);
		this.updateForm();
		this.f.description.setValue(this.model.ProductName);
	}

	onSelectedModel(): void {
		this.filterBoards = this.filterModels.filter(m => m.ProductName === this.f.selectedModel.value.ProductName);
		if (this.filterBoards !== null && this.filterBoards.length === 1) {
			this.f.selectedBoard.setValue(this.filterBoards[0]);
			this.onSelectedBoard();
		} else {
			this.f.selectedBoard.setValue(null);
		}
		//this.model = this.filterModels.find(m => m.Id === this.f.selectedModel.value.Id);
		//this.updateForm();
		//this.f.description.setValue(this.model.ProductName);
	}

	onSelectedBoard(): void {
		this.model = this.filterModels.find(m => m.Id === this.f.selectedBoard.value.Id);
		this.updateForm();
		// this.f.description.setValue(this.model.ProductName + (this.model.BoardName !== undefined ? ' - ' + this.model.BoardName : ''));
		this.f.description.setValue(this.model?.ProductName + (this.model?.BoardProductName !== undefined ? ' - ' + this.model?.BoardProductName : ''));
	}

	enableConfirmButtons(): boolean {
		return this.activeIndex > 0;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: AddAutomationDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: AddAutomationDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	getColorFirstTabCustom(): string {
		let colorTab = "border-left-none border-right-none border-top-none border-bottom-2";

		if (this.boardClassSel === undefined && !StandardNewValidator.getFirstCompile()) {
			colorTab = colorTab + " text-50 border-50";
		} else {
			colorTab = colorTab + " text-primary border-primary";
		}
		return colorTab;
	}

	getColorSecondTab(): string {
		return StandardNewValidatorStepTabs.getColorSecondTab(this.activeIndex);
	}

	showErrorRequiredCheckBox(type: AddAutomationDialogComponent["f"]): string {
		return StandardNewValidator.showErrorRequiredCheckBox(type);
	}
}